<template>
    <div class='container3' v-if="show" @click="$emit('close')">
        <div class="imagebox">
            <img src="@/assets/images/hvac/mapping/jiantou.png" alt="">
        </div>
        <div class="info">
            请点击右上角转发
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    // 组件注册
    components: {},
    data() {
        return {
        };
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    //计算属性
    computed: {},
    // 数据监听
    watch: {},
    //方法集合
    methods: {},
    //生命周期 - 创建完成
    created() { },
    //生命周期 - 挂载完成
    mounted() { },

    beforeCreate() { }, //生命周期 - 创建之前

    beforeMount() { }, //生命周期 - 挂载之前

    beforeUpdate() { }, //生命周期 - 更新之前

    updated() { }, //生命周期 - 更新之后

    beforeDestroy() { }, //生命周期 - 销毁之前

    destroyed() { }, //生命周期 - 销毁完成

    activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
.flc {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flc2 {
  display: flex;
  align-items: center;
}
.positionc {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.container3 {
  left: 0;
  top: 0;
  z-index: 9999999;
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba($color: #000000, $alpha: 0.5);
  .imagebox {
    display: flex;
    justify-content: flex-end;
    img {
      width: 100px;
      margin-right: 20px;
    }
  }
  .info {
    color: #ffffff;
    font-size: 35px;
      margin-right: 80px;
    text-align: right;
  }
}
</style>